import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);

  // Show button when page has scrollable content and determine position
  const toggleVisibility = () => {
    const scrollTop = window.pageYOffset;
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;

    // Show button if page has scrollable content (page is taller than viewport)
    const hasScrollableContent = documentHeight > windowHeight + 100; // 100px buffer
    setIsVisible(hasScrollableContent);

    // Determine if we're closer to top or bottom
    // If we're in the top portion of the page (first 200px), show "scroll to bottom"
    // Otherwise, show "scroll to top"
    setIsAtTop(scrollTop < 200);
  };

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Scroll to bottom smoothly
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  const handleClick = () => {
    if (isAtTop) {
      scrollToBottom();
    } else {
      scrollToTop();
    }
  };

  useEffect(() => {
    // Initial check immediately
    toggleVisibility();
    
    // Check again after a short delay to ensure DOM is fully loaded
    const initialTimer = setTimeout(() => {
      toggleVisibility();
    }, 100);

    // Check again after images and content might have loaded
    const contentTimer = setTimeout(() => {
      toggleVisibility();
    }, 500);

    // Add event listeners
    window.addEventListener('scroll', toggleVisibility);
    window.addEventListener('resize', toggleVisibility);
    window.addEventListener('load', toggleVisibility);
    
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(contentTimer);
      window.removeEventListener('scroll', toggleVisibility);
      window.removeEventListener('resize', toggleVisibility);
      window.removeEventListener('load', toggleVisibility);
    };
  }, []);

  // Also check when component mounts and after any potential route changes
  useEffect(() => {
    const routeTimer = setTimeout(() => {
      toggleVisibility();
    }, 200);

    return () => clearTimeout(routeTimer);
  }, [window.location.pathname]);

  return (
    <>
      {isVisible && (
        <button
          className="scroll-to-top-button"
          onClick={handleClick}
          aria-label={isAtTop ? "Scroll to bottom" : "Scroll to top"}
        >
          {isAtTop ? (
            // Down arrow for scroll to bottom
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 5V19M5 12L12 19L19 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            // Up arrow for scroll to top
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 19V5M5 12L12 5L19 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;